import { convertToMoney } from "commons/src/Money";

const isEmpty = value => {
    return value === undefined || value === null;
};

export const getRemainingAllowance = (totalAllowance, totalSubscriptionCTY, isPension) => {
    if (isEmpty(totalAllowance) || isEmpty(totalSubscriptionCTY)) return "";
    const finalAmount = totalAllowance - totalSubscriptionCTY;
    if (isPension) {
        return finalAmount < 0 ? "-" : convertToMoney(finalAmount);
    } else {
        return convertToMoney(Math.max(0, finalAmount));
    }
};
